/** Эталонная рамка 16:9 — те же единицы, что и pan/zoom в админке */
export const CAROUSEL_FRAME_W = 1600;
export const CAROUSEL_FRAME_H = 900;

export function getPhotoCoverLayout(nw, nh, zoom) {
  const cw = CAROUSEL_FRAME_W;
  const ch = CAROUSEL_FRAME_H;
  if (!nw || !nh) {
    return { scale: 1, dispW: cw, dispH: ch, cw, ch };
  }
  const baseScale = Math.max(cw / nw, ch / nh);
  const scale = baseScale * zoom;
  return {
    scale,
    dispW: nw * scale,
    dispH: nh * scale,
    cw,
    ch,
  };
}

export function clampPhotoPan(panX, panY, nw, nh, zoom) {
  const { dispW, dispH, cw, ch } = getPhotoCoverLayout(nw, nh, zoom);
  const minX = cw - dispW;
  const minY = ch - dispH;
  return {
    panX: Math.min(0, Math.max(minX, panX)),
    panY: Math.min(0, Math.max(minY, panY)),
  };
}

export function resetPanCentered(nw, nh, zoom) {
  const { dispW, dispH, cw, ch } = getPhotoCoverLayout(nw, nh, zoom);
  return {
    panX: (cw - dispW) / 2,
    panY: (ch - dispH) / 2,
  };
}

export function parseCropZoom(v) {
  const n = Number(v);
  if (!Number.isFinite(n)) return 1;
  return Math.min(3.5, Math.max(1, n));
}
